/**
 * Builds a URL query string from a filters object.
 * Filters out undefined, null, and empty string values.
 *
 * @param filters - Object with key-value pairs to convert to query params
 * @returns URL-encoded query string (without leading ?)
 *
 * @example
 * buildQueryParams({ page: 1, search: 'test', status: undefined })
 * // Returns: "page=1&search=test"
 */
export function buildQueryParams(filters: object): string {
  const params = new URLSearchParams()

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      for (const v of value) {
        if (v !== undefined && v !== null && v !== '') {
          params.append(`${key}[]`, String(v))
        }
      }
      return
    }
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value))
    }
  })

  return params.toString()
}

/**
 * Parses a query string back into an object.
 *
 * @param queryString - URL query string (with or without leading ?)
 * @returns Object with parsed key-value pairs
 */
export function parseQueryParams(queryString: string): Record<string, string> {
  const params = new URLSearchParams(queryString.replace(/^\?/, ''))
  const result: Record<string, string> = {}

  params.forEach((value, key) => {
    result[key] = value
  })

  return result
}
